<template>
<div>
  <v-layout row justify-end>
    <v-dialog v-model="createFile" max-width="700">
      <v-btn flat slot="activator" color="green lighten-2" light>
        <v-icon class="mr-1" small>add_box</v-icon> Add File</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Add File</span>
        </v-card-title>
        <v-card-text>
          <v-text-field color="green lighten-2" label="Upload file" @click='pickFile' v-model='assetUrl' prepend-icon='attach_file' v-validate="'required'" :error-messages="errors.collect('assetUrl')" data-vv-name="assetUrl" hint="Upload image, audio, or video files"
            required></v-text-field>
          <input style="display: none" @change="onFilePicked($event);" accept="image/*,video/*,audio/*" ref="image" type="file" name="" id="">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="clearValid()">
            Cancel
          </v-btn>
          <v-btn color="green lighten-2" flat @click="addFile">
            Add File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  <v-card flat tile class="text-xs-left px-2 pt-1 mb-2" v-for="(file, idx) in files" :key="idx">
    <v-layout>
      <v-flex xs5>
        <v-icon>image</v-icon>
        <v-img :src="file.assetUrl" height="125px" contain></v-img>
      </v-flex>
      <v-flex xs7>
        <v-card-title primary-title>
          <div>
            <h4>File actions</h4>
            <div class="py-2">
              <a :href="file.assetUrl" class="mr-2" target="_blank" small>
                Download <v-icon color="green" small>cloud_download</v-icon>
              </a>
              <a class="d-inline-block mt-2" small fab flat color="red" @click="openDelete(file.id)">
                <span class="red--text">Delete</span> <v-icon color="red" small>delete</v-icon>
              </a>
            </div>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
    <v-dialog v-model="removeFile" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Post</span>
        </v-card-title>
        <v-card-text>
          <p>Are you sure you want to permanently delete this file?</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-2" flat @click="removeFile = false">
            Cancel
          </v-btn>
          <v-btn color="red" outline @click="deleteFile(file.id)">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</div>
</template>
<script>
import firebase, {
  FirebaseConsts,
  Storage,
  db
} from "@/firebaseConfig";
let fileRef = Storage.ref();
export default {
  name: "UpFile",
  data() {
    return {
      files: [],
      assetUrl: '',
      createFile: false,
      removeFile: false,
      editDetails: {
        id: ''
      },
      dictionary: {
        custom: {
          assetUrl: {
            required: () => 'Please select an image',
            // custom messages
          }
        }
      },
      image: null
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    addFile() {
      this.$validator.validateAll()

      let path = "files/" + Math.random().toString(36).substring(2, 15);

      // Upload new files
      fileRef
        .child(path)
        .put(this.image)
        .then(() => {
          this.createFile = false
          fileRef
            .child(path)
            .getDownloadURL()
            .then(url => {
              this.assetUrl = url

              db.collection("projects")
                .doc(this.$route.params.groupID)
                .collection("files")
                .add({
                  addedAt: Date.now(),
                  assetUrl: url
                });
              this.assetUrl = ''
              this.$validator.reset()
            });
        });
    },
    openDelete(id) {
      this.removeFile = true
      this.editDetails.id = id
    },
    deleteFile(id) {
      var id = this.editDetails.id
      db.collection("projects").doc(this.$route.params.groupID).collection('files').doc(id).delete()
      this.removeFile = false
    },
    clearValid() {
      this.createFile = false;
      this.$validator.reset();
    },
    loadGroupFiles() {
      this.$bind(
        "files",
        db
        .collection("projects")
        .doc(this.$route.params.groupID)
        .collection("files")
        .orderBy("addedAt", "desc")
      ).then(files => {
        this.files === files;
      });
    },
    handleFile(event) {
      this.assetUrl = event.target.files[0];
    },
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.assetUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    }
  },
  created() {
    this.loadGroupFiles();
  },
  watch: {
    // Reload the group's messages when the user switches groups
    "$route.params.groupID" (id) {
      this.loadGroupFiles();
    }
  }
};
</script>

<style lang="scss" scoped>
$main-color: #388E3C;
$text-color: #4c4c4c;
$text-color-light: #cccccc;
$bg-color: #a1eec4;
$hover-color: #f7f7f7;
$neutral-color: #ffffff;
.v-input input {
    width: 100%;
    min-width: 100vw;
}
.ql-toolbar.ql-snow {
    background: #f2f2f2;
    background-color: #f2f2f2;
}
.complete {
    text-decoration: line-through;
    color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/Posts/UpFile.vue